import * as types from './mutation-types'

export default {
  [types.LOAD_ROOMS](state, data) {
    state.rooms = data.rooms
  },
  [types.ADD_ROOM] (state, data) {
    state.rooms.push(data.room)
  },
}
